<template>
  <div>
    <InfosCommercialMobile :showContact="showContact"/>
    <ActionsModal v-if="afficheBloc"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import InfosCommercialMobile from './blocInfosMobile/InfosCommercialMobile';
import ActionsModal from './blocInfosMobile/ActionsModal';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  components: {
    InfosCommercialMobile,
    ActionsModal,
  },
  data: () => ({
    showContact: true,
  }),
  computed: {
    ...Recommandation.mapGetters({
      getPdv: 'pdv',
    }),
    afficheBloc() {
      if (this.getPdv.enseigne === 'GEANT CASINO') return false;
      if (this.getPdv.enseigne === 'FRANPRIX') return false;
      if (this.getPdv.enseigne === 'SUPERMACHE CASINO') return false;
      else return true;
    }
  },
};
</script>

<style>

</style>